<!--新闻管理-->
<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">官网新闻</p>
    <div class="formStyle">
      <p class="formTitle">新闻信息</p>
      <Form :model="formItem" :label-width="100" style="padding:20px">
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">封面图</Col>
            <Col span="15">
              <img :src="formItem.titleImgUrl" style="width: 150px; height:150px">
            </Col>
          </Row>
        </formItem><!--封面图-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">主标题</Col>
            <Col span="15">
              <Input v-model="formItem.mainTitle" readonly></Input>
            </Col>
          </Row>
        </formItem><!--主标题-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">来源</Col>
            <Col span="15">
              <Input v-model="formItem.source" readonly></Input>
            </Col>
          </Row>
        </formItem><!--来源-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">新闻类别</Col>
            <Col span="15">
              <RadioGroup v-model="formItem.newsCategory">
                <Radio label="1" disabled>公司新闻</Radio>
                <Radio label="2" disabled>行业动态</Radio>
                <Radio label="3" disabled>媒体报导</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </formItem><!--类别-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">发布时间</Col>
            <Col span="5">
              <Input v-model="formItem.time" readonly></Input>
            </Col>
            <!--<Col span="2">——</Col>-->
            <!--<Col span="5">-->
            <!--<TimePicker type="time" placeholder="Select time" v-model="formItem.publicTime"></TimePicker>-->
            <!--</Col>-->
          </Row>
        </formItem><!--发布时间-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">简介</Col>
            <Col span="15">
              <Input v-model="formItem.summary" readonly></Input>
            </Col>
          </Row>
        </formItem><!--副标题-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">详细内容</Col>
            <Col span="15">
              <Input v-model="formItem.content" type="textarea" readonly
                     :autosize="{minRows: 4,maxRows: 8}"
                     placeholder="请输入详细内容..."></Input>
            </Col>
          </Row>
        </formItem><!--副标题-->
        <formItem style="text-align: center">
          <Button type="primary" @click="editNewsInfo(formItem.id)">编辑新闻</Button>
        </formItem>
      </Form>
    </div>

  </div>
</template>

<script>
    import {format2Sec} from "../../utils/format";
    import {adminRouter} from "../../router/admin";

    export default {
        name: "newsInfo",
        data(){
            return{
                formItem:{},
                imgPath:[]//上传的图片地址
            };
        },
        methods:{
            editNewsInfo(id){
                let active = 'editNewsInfo';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("newsId", id);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            }
        },
        activated() {
            this.formItem = {};
            let id = Number(localStorage.getItem('newsId'));
            this.$http.get('/zm/WMWebsite/queryNewsInfos').then(
                res => {
                    let tempList = res.data.content;
                    tempList.forEach((item) => {
                        if (item.id === id){
                            this.formItem = item;
                            this.formItem.time = format2Sec(this.formItem.publicDate);
                            this.formItem.newsCategory = String(this.formItem.newsCategory);
                        }
                    });
                }
            );
        }
    };
</script>

<style scoped>
  .container {
    padding: 0;
    margin: 20px 0 0 25px;
  }  /*全局配置*/
  .formStyle{
    background-color: #fff;
    margin:2% auto;
    width: 96%;
    border-radius: 5px;
  }  /*表单外观设置*/
  .formTitle{
    font-size: 20px;
    font-family: "黑体";
    padding:15px;
    text-align: center;
  }  /*表单标题*/
  .formItemTitle{
    font-size: 18px;
  }  /*表单项目标题*/
</style>



// WEBPACK FOOTER //
// newsInfo.vue?664166b9